import {createBrowserHistory} from 'history';
import {getUserConfirmation} from './util/nav-confirm';


// getUserConfirmation must be passed to the history factory (the low-level
// <Router> ignores it) so <Prompt> shows our custom modal instead of window.confirm.
export default createBrowserHistory({getUserConfirmation});
